import { IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { NamedEntityDto } from '../clinical-details';
import { BaseCreateDto, BaseUpdateDto } from '../base.dto';

export type SimplifiedDiagnosisDescriptionDto = NamedEntityDto;

export class CreateSimplifiedDiagnosisDescriptionDto extends BaseCreateDto {
  @IsNotEmpty()
  @IsString()
  name: string;

  @IsOptional()
  @IsString()
  name_da?: string;

  @IsOptional()
  @IsString()
  name_de?: string;
}

export class UpdateSimplifiedDiagnosisDescriptionDto extends BaseUpdateDto {
  @IsOptional()
  @IsNotEmpty()
  @IsString()
  name?: string;

  @IsOptional()
  @IsString()
  name_da?: string;

  @IsOptional()
  @IsString()
  name_de?: string;
}
